module.exports = __webpack_public_path__ + "static/feature3-a3aa6687fa279dbc3488c9066b372d62.mp4";